import PackagePhonePreview, { type PackagePhonePreviewProps } from './PackagePhonePreview';
import type { PackagesT } from './packagesI18n';

export interface PackagePreviewPaneProps {
  t: PackagesT;
  phone: PackagePhonePreviewProps;
  onLangChange: (lang: 'en' | 'ar') => void;
  onThemeChange: (theme: 'light' | 'dark') => void;
}

/** Right pane: EN/AR + light/dark toggles (44 px targets) over the phone preview; sticky on wide screens. */
export default function PackagePreviewPane({ t, phone, onLangChange, onThemeChange }: PackagePreviewPaneProps) {
  const seg = <V extends string>(value: V, current: V, label: string, onPick: (v: V) => void) => (
    <button type="button" aria-pressed={current === value} className={current === value ? 'is-on' : ''} onClick={() => onPick(value)}>
      {label}
    </button>
  );
  return (
    <aside className="pkg-editor__preview" aria-label={t('packages.preview.title')}>
      <div className="pkg-preview-controls">
        <div className="offer-segment pkg-segment" role="group" aria-label={t('packages.preview.language')}>
          {seg('en', phone.lang, t('packages.preview.en'), onLangChange)}
          {seg('ar', phone.lang, t('packages.preview.ar'), onLangChange)}
        </div>
        <div className="offer-segment pkg-segment" role="group" aria-label={t('packages.preview.theme')}>
          {seg('light', phone.theme, t('packages.preview.light'), onThemeChange)}
          {seg('dark', phone.theme, t('packages.preview.dark'), onThemeChange)}
        </div>
      </div>
      <PackagePhonePreview {...phone} />
    </aside>
  );
}
